<ion-app *ngIf="appLoaded">
  <app-sidemenu contentId="main"></app-sidemenu>
  <ion-router-outlet id="main" [swipeGesture]="false" [ngClass]="{'push': showTabs}"></ion-router-outlet>
  <app-footer-tabs *ngIf="showTabs"></app-footer-tabs>
</ion-app>
